export const wspTypeData = [
     {
    label: "NAKURU",
    value: "NAKURU",
  },
  {
    label: "NYERI",
    value: "NYERI",
  }, 
];